import React, { useEffect, useState } from "react";
import { Box } from "@material-ui/core";
import Sidebar from "./sidebar";
import TopBar from "./topbar";
import Breadcrumbs from "../components/BreadCrumbs"
import useStyles from "../assests/styles/layout/main"
import clsx from 'clsx';
import { useDispatch } from "react-redux";
import { Outlet } from "react-router";
import { Get } from "../actions";
import { Get_LanguageDictionary_URL } from "../constants/apiUrls";





export default function DashboardLayout(props) {
  const classes = useStyles();
  const [navOpen, setNavOpen] = useState(true);
  const [loadingTranslation,setLoadingTranslation]=useState(true)
  const dispatch = useDispatch();
  useEffect(
    ()=>{
      if(window.innerWidth<1000)
        setNavOpen(false);
      else
        setNavOpen(true);
    }
    ,[])
    useEffect(() => {
      getUpdatedTranslation();
    }, []);
    const getUpdatedTranslation = () => {
      Get(
        {},
        Get_LanguageDictionary_URL,
        null,
        (resp) => {
          if (resp?.data) {
            localStorage.setItem("dictionary", JSON.stringify(resp.data));
          }
          // alert(localStorage.getItem("lang"))
          if (localStorage.getItem("lang") === null) {
            localStorage.setItem("lang", "fr");
            window.location.reload();
          } 
          setLoadingTranslation(false);
        },
        (error) => {
          setLoadingTranslation(false)
        }
      );
    };
  return (
    <div className={classes.root}>
      <TopBar className="" navOpen={navOpen} handleDrawerOpen={()=>setNavOpen(true)} />
      <Sidebar
        onMobileClose={() => setNavOpen(false)}
        openMobile={navOpen}
      />
       <main  className={clsx(classes.content, {
          [classes.contentShift]: navOpen,
        })}>
            <Box mb={2} className={classes.breadcrums} >
              <Breadcrumbs />
            </Box>
            <Outlet/>
          </main>
    </div>
  );
}
